/// <reference path="./../Entity/PageHead.ts" />
namespace HA.Core.Service {

    import Head = HA.Core.Entity.PageHead;

    export class PageHead extends Service {
        /**
         *
         * @param data
         */
        public add2Head(data?: any) {
            this.getHead().add2Head(data);
        }

        /**
         *
         * @returns Head
         */
        public getHead(): Head {
            return this.get("head");
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: any) {
            super.initialize(data);
            this.addToData("head", new Head(data));
        }
    }
}
